import * as React from 'react';

import { cn } from '../lib/cn';

/**
 * Bottom-left, non-modal notice. Announced politely and never focus-trapped, so it can
 * sit there while someone keeps working. Offset past the sidebar on large screens so it
 * doesn't cover the nav footer.
 */
export const Snackbar = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    role="status"
    aria-live="polite"
    className={cn(
      'fixed bottom-4 left-4 z-50 flex max-w-[calc(100vw-2rem)] items-center gap-3 rounded-xl border border-border bg-background px-4 py-3 shadow-lg animate-slide-in-from-bottom sm:max-w-md lg:left-[256px]',
      className
    )}
    {...props}
  >
    {children}
  </div>
));
Snackbar.displayName = 'Snackbar';
